import React, { useEffect, useMemo, useState, useCallback } from "react";
import {
  Section,
  Controls,
  Field,
  Label,
  Select,
  Input,
  Presets,
  GhostButton,
} from "./styles";
import { getTaskData } from "api/taskStatus";
import { instanceAPI } from "api";

const getISOStringForInput = (date: Date) => {
  const pad = (n: number) => n.toString().padStart(2, "0");
  const yyyy = date.getFullYear();
  const MM = pad(date.getMonth() + 1);
  const dd = pad(date.getDate());
  const hh = pad(date.getHours());
  const mm = pad(date.getMinutes());
  return `${yyyy}-${MM}-${dd}T${hh}:${mm}`;
};

const FiltersPanel = ({
  valueInstance,
  onChangeInstance,
  start,
  end,
  onChangeStart,
  onChangeEnd,
}) => {
  const [options, setOptions] = useState([]);

  useEffect(() => {
    let mounted = true;
    const fetch = async () => {
      const names = (await getTaskData(instanceAPI.getInstnaceList)).result
        .data;

      if (mounted) setOptions(names);
    };
    fetch();
    return () => {
      mounted = false;
    };
  }, []);

  const presetSet = useCallback(
    (minutes: number) => {
      const now = new Date();
      const endSafe = new Date(now.getTime() - 60 * 1000);
      const startAt = new Date(endSafe.getTime() - minutes * 60 * 1000);
      onChangeStart(getISOStringForInput(startAt));
      onChangeEnd(getISOStringForInput(endSafe));
    },
    [onChangeStart, onChangeEnd]
  );

  const minEnd = useMemo(() => (start ? start : undefined), [start]);
  const maxStart = useMemo(() => (end ? end : undefined), [end]);

  return (
    <Section>
      <Controls>
        <Field>
          <Label>Instance</Label>
          <Select
            id="instance"
            value={valueInstance}
            onChange={(e) => onChangeInstance(e.target.value)}
            title={valueInstance}
          >
            {!valueInstance && <option value="">선택하세요</option>}
            {options.map((name) => (
              <option key={name} value={name}>
                {name}
              </option>
            ))}
          </Select>
        </Field>

        <Field>
          <Label>Start</Label>
          <Input
            id="start"
            type="datetime-local"
            value={start}
            max={maxStart}
            onChange={(e) => onChangeStart(e.target.value)}
          />
        </Field>

        <Field>
          <Label>End</Label>
          <Input
            id="end"
            type="datetime-local"
            value={end}
            min={minEnd}
            onChange={(e) => onChangeEnd(e.target.value)}
          />
        </Field>

        <Presets>
          <GhostButton onClick={() => presetSet(10)}>최근 10분</GhostButton>
          <GhostButton onClick={() => presetSet(60)}>최근 1시간</GhostButton>
          <GhostButton onClick={() => presetSet(360)}>최근 6시간</GhostButton>
          <GhostButton onClick={() => presetSet(1440)}>최근 24시간</GhostButton>
        </Presets>
      </Controls>
    </Section>
  );
};

export default FiltersPanel;
